import jobReducer from './job/jobSlice';
import stagesReducer from './interview/stagesSlices';
import interviewTabRefreshReducer from './interview/interviewTabRefreshSlice';
import onboardRefreshReducer from './onboard/onboardDetailsRefreshSlice';
import onboardReducer from './onboard/onboardSlice';
import vendorReducer from './vendor/vendorSlice';
import onboardListingReducer from './onboard/onboardListingSlice';
import candidateReducer from './candidate/candidateSlice';
import candidateListReducer from './candidate/candidateListSlice';
import candidateAttachmentReducer from './candidateDocumentStatus/candidateDocumentStatusSlice';
import updateOfferReducer from "./offer/updateOfferSlice"
import departmentReducer from './department/departmentSlice';

const recruitmentReducers = {
    job: jobReducer,
    interviewStage: stagesReducer,
    interviewTabRefresh: interviewTabRefreshReducer,
    onboardDetailsRefresh: onboardRefreshReducer,
    onboard: onboardReducer,
    vendor: vendorReducer,
    onboardListing: onboardListingReducer,
    candidate: candidateReducer,
    candidateList: candidateListReducer,
    candidateAttachment:candidateAttachmentReducer,
    offer: updateOfferReducer,
    department : departmentReducer

};

export default recruitmentReducers;
